<template lang="pug">
  .add-post-optional
    .add-post-header
      EntityAvatar(:image="$auth.user().avatar" size-class="is-48x48" is-rounded)
      .add-post-header-meta
        .add-post-username {{ $auth.user().name }}
        .add-post-subtitle Log {{ activityLabel }}
      a.add-photo-icon(@click="showPhotoUpload = true")
        BIcon.has-text-grey(icon="image-plus")

    .add-post-text-input
      BInput(
        type="textarea"
        v-model="postText"
        maxlength="1000"
        placeholder="Write something..."
        :has-counter="false"
      )

    .photo-upload-container(v-if="showPhotoUpload && !previewImageData")
      BField
        BUpload.photo-upload(
          drag-drop
          native
          expanded
          accept="image/jpeg, image/gif, image/png"
          @input="previewImage"
        )
          .file-uploader
            .file-contents
              span.file-label Drop your files here or click to upload
              BIcon.file-icon.is-medium(icon="upload")
      p.has-text-danger.has-text-centered(v-if="imageCompressorError")
        | There was a problem reading that image. Please try another one.

    .preview-image-container(v-if="previewImageData")
      .preview-thumb
        img.preview-image(:src="previewImageData" alt="Your Photo")
        a.remove-image-btn(@click="removeImage" role="button" aria-label="Remove photo")
          BIcon(icon="close" size="is-small")

    .submit-container
      WtButton.submit-post-button(
        @click.native="submitPost"
        :loading="submitting"
        :disabled="submitting"
      ) Submit
</template>

<script>
import imageCompression from "browser-image-compression";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";
import WtButton from "@@/WtButton/WtButton.vue";

export default {
  name: "AddPostOptional",

  components: {
    EntityAvatar,
    WtButton
  },

  props: {
    activityName: {
      type: String,
      required: true
    },

    submitting: {
      type: Boolean,
      default: false
    },

    initialText: {
      type: String,
      default: ""
    },

    initialImage: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      postText: this.initialText,
      previewImageData: this.initialImage,
      showPhotoUpload: false,
      imageCompressorError: false,
      newPhoto: null,
      imageRemoved: false
    };
  },

  computed: {
    // "Heart Rate" -> "Heart rate", matching the mobile subtitle
    activityLabel() {
      return this._.capitalize(this.activityName);
    }
  },

  methods: {
    submitPost() {
      this.$emit("submit-post", {
        text: this.postText.trim(),
        image: this.newPhoto,
        imageRemoved: this.imageRemoved && !this.newPhoto
      });
    },

    removeImage() {
      if (this.initialImage && this.previewImageData === this.initialImage) {
        this.imageRemoved = true;
      }
      this.previewImageData = "";
      this.newPhoto = null;
      this.showPhotoUpload = true;
    },

    async previewImage(file) {
      const options = {
        maxSizeMB: 10,
        maxWidthOrHeight: 1920,
        useWebWorker: true
      };

      try {
        this.imageCompressorError = false;
        const blob = await imageCompression(file, options);

        this.newPhoto = blob;
        this.previewImageData = await imageCompression.getDataUrlFromFile(blob);
      } catch (error) {
        this.imageCompressorError = true;
      }
    }
  }
};
</script>

<style scoped lang="sass">
.add-post-optional
  display: flex
  flex-direction: column
  gap: 16px
  width: 100%

  .add-post-header
    display: flex
    flex-direction: row
    align-items: center
    gap: 12px
    .add-post-header-meta
      flex: 1
    .add-post-username
      font-weight: 600
      font-size: 16px
      line-height: 24px
      color: #1B1D20
    .add-post-subtitle
      font-weight: 400
      font-size: 14px
      line-height: 20px
      color: #5D6472
    .add-photo-icon
      display: flex
      align-items: center

  .add-post-text-input
    /deep/ textarea
      border: none
      box-shadow: none
      resize: none
      min-height: 160px
      font-size: 16px
      padding-left: 0
      &:focus
        border: none
        box-shadow: none
        outline: none
    /deep/ .b-input-counter
      display: none !important

  .file-uploader
    display: flex
    align-items: center
    justify-content: center
    width: 100%
  .file-contents
    display: flex
    flex-direction: row
    gap: 8px
    align-items: center

  .preview-image-container
    display: flex
    .preview-thumb
      position: relative
      display: inline-flex
      .preview-image
        width: 139px
        max-height: 160px
        object-fit: cover
        border-radius: 8px
        display: block
      .remove-image-btn
        position: absolute
        top: -8px
        right: -8px
        display: flex
        align-items: center
        justify-content: center
        width: 28px
        height: 28px
        border-radius: 50%
        background: #FFFFFF
        color: #1B1D20
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2)

  .submit-container
    display: flex
    flex-direction: column
    border-top: 1px solid #E8EBEF
    padding-top: 16px
    .submit-post-button
      background-color: #2972F0
      color: #FFFFFF
      border-radius: 10px
      font-size: 16px
      font-weight: 600
      height: 44px
      border: none
</style>
